export const boxStyles = {
  width: "220px",
  // important needed to overwrite default MUI styling
  margin: "0 0 0 auto !important",
};

export const tabsStyles = {
  ".MuiTabs-flexContainer": {
    alignItems: "baseline",
  },

  ".MuiTabs-indicator": {
    display: "none",
  },
};

export const tabStyles = {
  "&.MuiTab-root": {
    minWidth: "48px",
    fontWeight: 400,
    color: "black",
    padding: 0,
  },

  "&.Mui-selected": {
    fontSize: "1rem",
    fontWeight: 700,
  },
};
